<template>
    <div>
        <div hidden>
            {{ time_countdown }}
        </div>
        <div v-if="time">
            <!-- <div class="flash_sale_title">{{ title }}</div> -->
            <div class="flash_sale">
                <div>
                    <span class="tw-bg-gray-100">{{ days }}</span>
                    <div class="smalltext tw-text-gray-400">วัน</div>
                </div>
                <div>
                    <span class="tw-bg-gray-100">{{ hours }}</span>
                    <div class="smalltext tw-text-gray-400">ชั่วโมง</div>
                </div>
                <div>
                    <span class="tw-bg-gray-100"> {{ minutes }}</span>
                    <div class="smalltext tw-text-gray-400">นาที</div>
                </div>
                <div>
                    <span class="tw-bg-gray-100"> {{ seconds }}</span>
                    <div class="smalltext tw-text-gray-400">วินาที</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        date: { type: Date, default: "" },
        title: { type: String, default: "" }
    },
    data() {
        return {
            time: null,
            distance: 1,
            days: null,
            hours: null,
            minutes: null,
            seconds: null
        };
    },
    computed: {
        time_countdown() {
            let self = this;
            if (this.distance > 0) {
                // start the interval timer
                this.updateTimer();
                return this.time;
            } else {
                return "Expire";
            }
        }
    },
    methods: {
        updateTimer() {
            let countDownDate = new Date(this.date).getTime();
            clearInterval(this.distance);

            if (this.distance > 0) {
                this.distance = setInterval(() => {
                    // console.log("tick...");
                    let now = new Date().getTime();
                    // Find the distance between now and the count down date
                    this.distance = countDownDate - now;
                    let distance = this.distance;
                    // console.log(this.distance);

                    // Time calculations for days, hours, minutes and seconds

                    if (distance > 0) {
                        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
                        let hours = Math.floor(
                            (distance % (1000 * 60 * 60 * 24)) /
                                (1000 * 60 * 60)
                        );
                        let minutes = Math.floor(
                            (distance % (1000 * 60 * 60)) / (1000 * 60)
                        );
                        let seconds = Math.floor(
                            (distance % (1000 * 60)) / 1000
                        );

                        this.days = String(days).padStart(2, "0");
                        this.hours = String(hours).padStart(2, "0");
                        this.minutes = String(minutes).padStart(2, "0");
                        this.seconds = String(seconds).padStart(2, "0");
                        this.time = `${days} Day ${hours} Hour ${minutes} Minute ${seconds} Second`;
                    }
                }, 1000);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.flash_sale_title {
    margin: 5px 0;
    font-size: 28px;
    color: red;
}
.flash_sale {
    // display: flex;
    color: #fff;
    font-weight: 100;
    text-align: center;
    font-size: 24px;
    display: inline-block;
    margin-bottom: 10px;
    min-width: 250px;
    & > div {
        // color: #fff;
        // background-color: #3c3737;
        // padding: 20px 10px;
        // display: flex;
        // flex-flow: column;
        // margin: 0 5px;
        // width: 100px;
        // justify-content: center;
        // border-radius: 5px;
        // box-shadow: 0 0 5px;
        padding: 10px;
        margin: 5px;
        border-radius: 3px;
        background: #f3f4f6;

        display: inline-block;
        span {
            &:first-child {
                // background-color: red;
                // border-radius: 5px;
                padding: 0 5px;
                border-radius: 3px;
                color: red;
                font-weight: 600;
                // background: #e3432f;
                display: inline-block;
                min-width: 45px;
                max-width: 45px;
            }
        }
        .smalltext {
            padding-top: 10px;
            font-size: 12px;
            font-weight: 600;
        }
    }
}
</style>
